import api from './api';

export const clientService = {
  async getAll() {
    const response = await api.get('/clientes');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/clientes/${id}`);
    return response.data;
  },

  async create(clientData) {
    const response = await api.post('/clientes', clientData);
    return response.data;
  },

  async update(id, clientData) {
    const response = await api.put(`/clientes/${id}`, clientData);
    return response.data;
  },

  async delete(id) {
    await api.delete(`/clientes/${id}`);
  },
};